import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { fetchDemoLeadCaptureEnabled } from 'src/app/services/demoLead';

/**
 * Whether the end-of-demo email form is on for the language the demo UI runs
 * in (backend DEMO_LEAD_ALLOWED_LOCALES). Off until known, on any failure, and
 * again on every language switch until the new answer is in.
 */
export const useDemoLeadCaptureEnabled = (): boolean => {
  const { i18n } = useTranslation();
  const language = i18n.language;
  const [enabled, setEnabled] = useState(false);
  useEffect(() => {
    let active = true;
    setEnabled(false);
    fetchDemoLeadCaptureEnabled(language).then((value) => {
      if (active) setEnabled(value);
    });
    return () => {
      active = false;
    };
  }, [language]);
  return enabled;
};
